<script>
    export let errors = null;
    const standardErrors = [
        'non_field_errors',
        'detail',
        'message',
        'media',
    ];
</script>

<style>

</style>

{#if errors}
    <div class="alert alert-danger" role="alert">
        {#if errors.non_field_errors}
            {#each errors.non_field_errors as er}
                <div>{er}</div>
            {/each}
        {/if}
        {#if errors.detail}
            <div>{errors.detail}</div>
        {/if}
        {#if errors.message}
            <div>{errors.message}</div>
        {/if}
        {#if errors.media}
            <div>{errors.media}</div>
        {/if}
        {#if typeof errors === 'string'}
            {errors}
        {:else}
            {#each Object.entries(errors) as error}
                {#if !standardErrors.includes(error[0]) }
                    <p>{error[0]}: {error[1]}</p>
                {/if}
            {/each}
        {/if}
    </div>
{/if}
